import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="border-t border-line bg-panel px-4 py-16 sm:py-20" aria-label="Do any of these sound familiar" data-id="element-229" data-mp="26xwjuucs03mc">
      <div className="mx-auto max-w-4xl" data-id="element-230" data-mp="2bvfw5opwy6bn">
        <SectionHeading kicker="Do any of these sound familiar?" title={<>
              If you’ve faced these situations, <span className="text-amber" data-id="element-232" data-mp="220o1asnptxkk">this was designed for you</span>
            </>} data-id="element-231" data-mp="1xx82pqs35n58" />

        <ol className="divide-y divide-line" data-id="element-233" data-mp="1o1oe7pfupqqi">
          {painPoints.map((p, i) => <li key={p.title} className="flex gap-4 py-6 sm:gap-6" data-id="element-234" data-mp="1sywufkhfvkp4" data-mpi={i}>
              <span className="font-display text-5xl font-extrabold leading-none text-signal sm:text-6xl" data-id="element-235" data-mp="3iemle069879m">{i + 1}</span>
              <div data-id="element-236" data-mp="3nc5y2vnb0bzg">
                <h3 className="font-display text-2xl font-bold uppercase leading-tight text-white sm:text-[28px]" data-id="element-237" data-mp="3nalbptb57zco">
                  {p.title}
                </h3>
                <p className="mt-2 text-[16px] leading-relaxed text-mist" data-id="element-238" data-mp="1u0smomhu7ry3">{p.body}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-10 rounded-2xl border-l-4 border-amber bg-panel2 p-6 sm:p-8" data-id="element-239" data-mp="27uth541rassn">
          <p className="flex items-center gap-2 font-display text-xl font-bold uppercase text-amber" data-id="element-240" data-mp="23trc26l5rmir">
            <AlertTriangleIcon className="h-5 w-5" aria-hidden="true" data-id="element-241" data-mp="1g3njqvdf7972" />
            Here’s what I want you to understand…
          </p>
          <div className="mt-4 space-y-4 text-lg leading-relaxed text-mist" data-id="element-242" data-mp="1p2r5660280oq">
            <p data-id="element-243" data-mp="1k3eaiz2y5pbl">The problem isn’t always that you don’t know enough about cars.</p>
            <p className="text-white" data-id="element-244" data-mp="1k5qzhw74gzy5">
              Sometimes, the problem is that you don’t have a <strong data-id="element-245" data-mp="30jqviw2uk5g4">consistent process</strong> for organizing
              diagnostic information.
            </p>
            <p data-id="element-246" data-mp="2vkxjl837kmi2">
              A code tells you that a system has detected a condition. Your job is to investigate{' '}
              <em className="text-white" data-id="element-247" data-mp="1y3qcicjqrpn1">why</em> that condition occurred. The OBD2 Diagnostic Blueprint™ connects
              those steps into one organized workflow.
            </p>
          </div>
        </div>

        <CtaButton className="mt-10" label="Get the complete Blueprint" sub="One-time payment of $27 · Lifetime access" data-id="element-248" data-mp="2756d5skr8de2" />
      </div>
    </section>;
}